module.exports = __webpack_public_path__ + "static/why-fullCoverage-009d7a659756c0fcdf4564e1db267db4.svg";